import {ActionWithPayload} from '../../../helpers/reduxHelpers';
import {findPanelSequence} from '../../../services/panels';
import {ThunkAction} from '../../appThunk';
import {PanelActionPayload, setPanelAction} from '../panelsActions';
import {getPanels} from '../panelsSelectors';
import {LegacyPanelId, PanelTypesEnum} from '../panelStateBase';

/*
 * Type enum.
 */

export enum LegacyPanelActionsEnum {
  NAVIGATED = '@@panels/legacy/NAVIGATED',
}

/*
 * Types.
 */

type LegacyPanelActionPayload = PanelActionPayload<LegacyPanelId>;

interface LegacyNavigatedActionPayload extends LegacyPanelActionPayload {
  path: string;
}

interface LegacyNavigatedAction extends ActionWithPayload<LegacyNavigatedActionPayload> {
  type: LegacyPanelActionsEnum.NAVIGATED;
}

/*
 * Action creators.
 */

export function navigateLegacyAction(panelId: LegacyPanelId, path: string): ThunkAction {
  return (dispatch, getState) => {
    const panel = getPanels(getState())[panelId];
    if (panel && panel.type !== PanelTypesEnum.LEGACY) {
      throw new Error('Wrong panel type.');
    }

    if (panel) {
      dispatch<LegacyNavigatedAction>({
        type: LegacyPanelActionsEnum.NAVIGATED,
        payload: {panelId, path},
      });
      return;
    }

    dispatch(
      setPanelAction({
        id: panelId,
        type: PanelTypesEnum.LEGACY,
        path,
        sequence: findPanelSequence(),
      }),
    );
  };
}

/*
 * Union type.
 */

export type LegacyPanelAction = LegacyNavigatedAction;
